import { gameApi } from "../api/game.api";
import { homeApi } from "../../home/api/home.api";
import { wickets9Api } from "../api/wickets9.api";
import { ExchangeWindowopenorFocus } from "../../../assets/js/common";
import { CheckGameMaintenanceRequest } from "../models/requests/CheckGameMaintenanceRequest";
import { SHOW_MAINTENANCE_EVENT } from "../../../components/ui/modals/GameMaintenanceModal";
import errorModal from "../../../services/errorModal.service";
import localization from "../../../config/localization";
import { localStorageService } from "../../../services";

export async function launchWickets9(currentPath: string, accessModeSource: string): Promise<void> {
  const token = localStorageService.getItem<string>("token");

  if (!token) {
    window.location.href = "/login";
    return;
  }

  const verticalsResponse = await homeApi.fetchActiveVerticals();
  if (!verticalsResponse.isSuccess) {
    window.location.href = "/";
    return;
  }

  const W9Vertical = verticalsResponse.data?.details.find(
    v => v.name === "Exchange"
  );

  if (!W9Vertical) {
    throw new Error("Sports vertical not found");
  }

  const usersVerticalResponse = await homeApi.fetchUserVerticals();
  if (usersVerticalResponse.isSuccess) {
    const excluded = usersVerticalResponse.data?.verticalsCsv ?? "";

    if (excluded.toLowerCase().includes("exchange")) {
      window.location.href = "/";
      return;
    }
  }
  else {
    errorModal.showErrorModal(usersVerticalResponse.statusCode, usersVerticalResponse.message, false);
  }

  const checkGameMaintenanceRequest: CheckGameMaintenanceRequest = {
    verticalId: W9Vertical.id,
  };

  const maintenanceResponse =
    await gameApi.checkGameMaintenance(checkGameMaintenanceRequest);

  if (!maintenanceResponse.isSuccess) {
    errorModal.showErrorModal(maintenanceResponse.statusCode, maintenanceResponse.message);
    return;
  }

  if (maintenanceResponse.data?.message && maintenanceResponse.data?.fromdate && maintenanceResponse.data?.todate) {
    window.dispatchEvent(
      new CustomEvent(SHOW_MAINTENANCE_EVENT, {
        detail: {
          message: maintenanceResponse.data?.message,
          toDate: maintenanceResponse.data?.todate,
        },
      })
    );
    return;
  }

  const launchResponse = await wickets9Api.launch9Wickets();
  if (!launchResponse.isSuccess) {
    errorModal.showErrorModal(launchResponse.statusCode, launchResponse.message);
    return;
  }

  const launchUrl = launchResponse.data?.launchUrl;
  if (!launchUrl) {
    throw new Error("Launch URL missing");
  }

  localStorageService.setItem("gameUrl", launchUrl);

  if (launchUrl && launchUrl !== undefined) { }
  const isWindowOpened = ExchangeWindowopenorFocus(
    launchUrl,
    accessModeSource
  );

  if (!isWindowOpened) {
    errorModal.showErrorModal(400, localization.popup_blocker_redirect, false);
  }
}
